export default __webpack_public_path__ + "static/media/Todoimg.06db72f7.jpeg";